import { Loader2, Save } from "lucide-react";
import React from "react";
import { Constants } from "src/constant";
import { useFaqStore } from "src/store/faqStore";
import { slab } from "./faqConstants";
import { faqEqual } from "./faqUtils";

export const FaqSaveFooter: React.FC = () => {
  const saving = useFaqStore((s) => s.saving);
  const save = useFaqStore((s) => s.save);
  const isDirty = useFaqStore(
    (s) =>
      s.form != null &&
      s.savedBaseline != null &&
      !faqEqual(s.form, s.savedBaseline),
  );
  const saveDisabled = saving || !isDirty;

  return (
    <div className="mt-10 flex flex-col items-center gap-3 sm:items-start">
      {isDirty && (
        <p
          className="text-center text-sm font-extrabold text-[#FBBF24] sm:text-left"
          role="status"
        >
          Unsaved changes — save to update Firestore.
        </p>
      )}
      <button
        type="button"
        onClick={() => void save()}
        disabled={saveDisabled}
        className="flex min-h-[52px] w-full items-center justify-center gap-2 rounded-2xl border-0 px-6 text-sm font-extrabold uppercase tracking-wide text-white shadow-[0_6px_0_#0F766E] transition-transform active:translate-y-1 active:shadow-[0_2px_0_#0F766E] disabled:cursor-not-allowed disabled:opacity-60 disabled:active:translate-y-0 sm:w-auto"
        style={{ backgroundColor: slab.teal }}
      >
        {saving ? (
          <>
            <Loader2 className="h-5 w-5 animate-spin" aria-hidden />
            Saving…
          </>
        ) : (
          <>
            <Save className="h-5 w-5" aria-hidden />
            Save FAQ
          </>
        )}
      </button>
      <p className="text-sm text-white/60">{Constants.APP_FAQ_NOTE}</p>
    </div>
  );
};
